import styled from 'styled-components';
import {controlWithIcon} from '../../../common/shared/control-with-icon.styled';
import { StyledModal } from '../../../common/shared/modal.styled';

export const StyledSection = styled.section`
  #section-to-print {
    position: absolute; 
    bottom: 5000px;
    
    .print-column-one-time {
      max-width: 100px;
      min-width: 100px;
    }
    .print-column-months {
      padding: 0 4px;
      max-width: 60px;
      min-width: 60px;
      
      a {
        color: inherit;
        text-decoration: none;
      }
    }
    
    .pdf-rows-table {
      break-after: page;
    }

    .vertical-text {
      writing-mode: vertical-rl;
    }
    
    .months-print-table {
      .pdf-row {
        .print-column-months:nth-of-type(1) {
          max-width: 80px;
          min-width: 80px;
        }
        .print-column-months:nth-of-type(2) {
          max-width: 80px;
          min-width: 80px;
        }
        .print-column-months {
          word-break: break-all;
        }
      }
      
      .pdf-row:last-of-type {
        .print-column-months {
          word-break: break-all;
        }
      }
    }
  }

  .title-section {
    padding: 50px 0 30px;
  }
  .text-center {
    padding: 30px 0;
  }
  .table-title {
    h4, h3 {
      text-align: start
    }
  }

  .form-control.bllink-input-border {
    padding-left: 60px;
  }
  ${controlWithIcon()}
  #table {
    max-height: 500px;
    th:nth-child(n + 3), td:nth-child(n + 3) {
      border-left: none;
    }
    tr td {
      padding-top: 20px;
      padding-bottom: 20px;
    }
  }
  .explanation-section {
    padding: 20px 0;
    ul {
      display: flex;
      align-items: center;
      list-style: none;
      margin: 0;
      padding: 0;
    }
    li {
      display: flex;
      align-items: center;
      padding: 0 25px;
      color: #6a697c;
      font-size: 15px;
      img {
        margin: 0 5px;
      }
    }
  }

  .pen {
    cursor: pointer;
  }
`;

export const StyledUpdateFeesModal = styled(StyledModal)`
  .gridWrapper {
    display: grid; 
    grid-template-columns: repeat(3, 1fr);
    gap: 50px;
    margin-bottom: 20px;

    .header {
      width: fit-content;
    }
  }

  .monthWrapper {
    align-items: center; 
  }
`
